import { mergeMap } from './mergeMap';
export const flatMap = mergeMap;
